import { render, staticRenderFns } from "./checkPaperList.vue?vue&type=template&id=c78daae0&scoped=true"
import script from "./checkPaperList.vue?vue&type=script&lang=js"
export * from "./checkPaperList.vue?vue&type=script&lang=js"
import style0 from "./checkPaperList.vue?vue&type=style&index=0&id=c78daae0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c78daae0",
  null
  
)

export default component.exports